<template>
  <div :class="['container', narrow ? 'container-narrow' : '']">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'UIContainer',
  props: { narrow: { type: Boolean, default: false } }
}
</script>

<style scoped>
</style>


